export class PriceTag {
  constructor(
    id,
    cp,
    cur,
    t,
    tags,
  ) {
    this.id = id;
    this.cp = cp;
    this.cur = cur;
    this.t = t;
    this.tags = tags;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new PriceTag(
        input.id,
        input.cp,
        input.cur,
        input.icon_url,
        Tag.fromApiArray(input.tags),
      )
    }

    return new PriceTag();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => PriceTag.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [PriceTag.fromApiObject(input)];
    }

    return [];
  }

  /** @param {[Tag]} tags */
  static getLabelLowest(tags = []) {
    if (!tags?.length) return "";
    let result = "";

    for (let index = 0; index < tags.length; index++) {
      const tag = tags[index];
      result = tag.getLabel();
    }
    return result;
  }
}

export class Tag {
  constructor(
    period,
    periodUnit,
    price,
    tag,
  ) {
    this.period = period;
    this.periodUnit = periodUnit;
    this.price = price;
    this.tag = tag;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Tag(
        input.period,
        input.period_unit,
        input.price,
        input.tag,
      )
    }

    return new Tag();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Tag.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Tag.fromApiObject(input)];
    }

    return [];
  }

  /**
   * @param {[Tag]} tags 
   * @returns {boolean}
   */
  static hasLowestTag(tags = []) {
    if (!tags.length) return;
    let result = false;
    for (let index = 0; index < tags.length; index++) {
      const element = tags[index];
      if (element.tag === this.TAG_TYPE.LOWEST) {
        result = true;
        return result;
      }
    }
    return result;
  }

  getLabel() {
    const PERIOD_UNIT = {
      "hours": "common_hours",
      "minutes": "common_minutes",
      "seconds": "common_seconds",
      "days": "common_days",
    }
    return this.period ? $.i18n("checkout_lowestPriceLast", this.period, $.i18n(PERIOD_UNIT[this.periodUnit] || "common_days")) : $.i18n("checkout_lowestPriceAll");
  }

  static TAG_TYPE = {
    LOWEST: "lowest",
  }
}